import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "3",
  rx: "3",
  ry: "3",
  width: "906",
  height: "17"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "828",
  cy: "81",
  r: "11"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "863",
  cy: "81",
  r: "11"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "53",
  y: "73",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "254",
  y: "72",
  rx: "3",
  ry: "3",
  width: "299",
  height: "15"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("rect", {
  x: "610",
  y: "72",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("rect", {
  x: "4",
  y: "113",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "829",
  cy: "142",
  r: "11"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "864",
  cy: "142",
  r: "11"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("rect", {
  x: "54",
  y: "134",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("rect", {
  x: "255",
  y: "133",
  rx: "3",
  ry: "3",
  width: "299",
  height: "15"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("rect", {
  x: "611",
  y: "133",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "174",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "830",
  cy: "200",
  r: "11"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "865",
  cy: "200",
  r: "11"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("rect", {
  x: "55",
  y: "192",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("rect", {
  x: "256",
  y: "191",
  rx: "3",
  ry: "3",
  width: "299",
  height: "15"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("rect", {
  x: "612",
  y: "191",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("rect", {
  x: "6",
  y: "232",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "831",
  cy: "261",
  r: "11"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "866",
  cy: "261",
  r: "11"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("rect", {
  x: "56",
  y: "253",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("rect", {
  x: "257",
  y: "252",
  rx: "3",
  ry: "3",
  width: "299",
  height: "15"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("rect", {
  x: "613",
  y: "252",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("rect", {
  x: "7",
  y: "293",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "830",
  cy: "321",
  r: "11"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "865",
  cy: "321",
  r: "11"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("rect", {
  x: "55",
  y: "313",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("rect", {
  x: "256",
  y: "312",
  rx: "3",
  ry: "3",
  width: "299",
  height: "15"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("rect", {
  x: "612",
  y: "312",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("rect", {
  x: "6",
  y: "353",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "831",
  cy: "382",
  r: "11"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "866",
  cy: "382",
  r: "11"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("rect", {
  x: "56",
  y: "374",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("rect", {
  x: "257",
  y: "373",
  rx: "3",
  ry: "3",
  width: "299",
  height: "15"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("rect", {
  x: "613",
  y: "373",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("rect", {
  x: "4",
  y: "411",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "7",
  rx: "3",
  ry: "3",
  width: "2",
  height: "465"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("rect", {
  x: "898",
  y: "7",
  rx: "3",
  ry: "3",
  width: "2",
  height: "465"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "831",
  cy: "442",
  r: "11"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "866",
  cy: "442",
  r: "11"
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("rect", {
  x: "56",
  y: "434",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("rect", {
  x: "257",
  y: "433",
  rx: "3",
  ry: "3",
  width: "299",
  height: "15"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("rect", {
  x: "613",
  y: "433",
  rx: "3",
  ry: "3",
  width: "141",
  height: "15"
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "470",
  rx: "3",
  ry: "3",
  width: "897",
  height: "2"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("rect", {
  x: "1",
  y: "38",
  rx: "3",
  ry: "3",
  width: "906",
  height: "17"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "15",
  rx: "3",
  ry: "3",
  width: "68",
  height: "33"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("rect", {
  x: "171",
  y: "12",
  rx: "3",
  ry: "3",
  width: "149",
  height: "33"
}, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("rect", {
  x: "493",
  y: "13",
  rx: "3",
  ry: "3",
  width: "137",
  height: "33"
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("rect", {
  x: "731",
  y: "14",
  rx: "3",
  ry: "3",
  width: "72",
  height: "33"
}, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("rect", {
  x: "882",
  y: "12",
  rx: "3",
  ry: "3",
  width: "24",
  height: "33"
}, null, -1)
const _hoisted_54 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_55 = {
  class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_56 = {
  key: 0,
  class: "w-10px",
  style: {"padding-left":"20px"}
}
const _hoisted_57 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "fw-bold text-gray-600" }
const _hoisted_61 = {
  key: 0,
  class: "w-10px",
  style: {"padding-left":"20px"}
}
const _hoisted_62 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid"
}
const _hoisted_63 = ["value"]
const _hoisted_64 = {
  key: 1,
  class: "odd"
}
const _hoisted_65 = {
  colspan: "9",
  class: "dataTables_empty"
}
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_68 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", { value: "150" }, "150", -1)
const _hoisted_72 = [
  _hoisted_69,
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentLoader = _resolveComponent("ContentLoader")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "top")
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ContentLoader, {
            animate: true,
            viewBox: "0 0 900 475"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _hoisted_39,
              _hoisted_40,
              _hoisted_41,
              _hoisted_42,
              _hoisted_43,
              _hoisted_44,
              _hoisted_45,
              _hoisted_46,
              _hoisted_47,
              _hoisted_48,
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              _hoisted_53
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("table", {
            class: _normalizeClass([[_ctx.loading && 'overlay overlay-block'], "table align-middle fs-6 gy-5 dataTable no-footer"]),
            id: "kt_customers_table",
            role: "grid"
          }, [
            _createElementVNode("thead", {
              style: _normalizeStyle({ backgroundColor: _ctx.backgroundHeader ? 'var(--cor_layout_1)' : 'none' })
            }, [
              _createElementVNode("tr", _hoisted_55, [
                (_ctx.select)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          disabled: _ctx.loading || _ctx.getItems.length == 0,
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectAll) = $event)),
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.controlaSelectAll && _ctx.controlaSelectAll(...args)))
                        }, null, 40, _hoisted_58), [
                          [_vModelCheckbox, _ctx.selectAll]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: i,
                    onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                    style: _normalizeStyle([{ paddingLeft: _ctx.select ? '0px' : '20px' }, {"cursor":"pointer"}]),
                    class: _normalizeClass(["text-nowrap fs-7", [
                  cell.class,
                  _ctx.backgroundHeader && 'text-white',
                  cell.name && 'min-w-125px',
                  cell.sortable !== false && 'sorting',
                  cell.align ? `text-${cell.align}` : _ctx.tableHeader.length - 1 === i && 'text-center ps-4',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}desc` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}asc` &&
                    'sorting_asc',
                ]]),
                    tabindex: "0",
                    rowspan: "1",
                    colspan: "1"
                  }, _toDisplayString(cell.name), 15, _hoisted_59))
                }), 128))
              ])
            ], 4),
            _createElementVNode("tbody", _hoisted_60, [
              (_ctx.getItems.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: i,
                      class: "odd"
                    }, [
                      (_ctx.select)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_61, [
                            (!_ctx.ruleSelect || _ctx.ruleSelect(item))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _withDirectives((_openBlock(), _createElementBlock("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: item,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected) = $event)),
                                    key: i,
                                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.controlaSelect && _ctx.controlaSelect(...args)))
                                  }, null, 40, _hoisted_63)), [
                                    [_vModelCheckbox, _ctx.selected]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: i,
                          class: _normalizeClass(["text-break cor_texto_1 fs-6", [cell.class, _ctx.tableHeader.length - 1 === i  &&'text-end', _ctx.tableHeader.length - 1 === i  && 'pe-2', _ctx.tableHeader.length - 1 === i  && 'min-w-175px']]),
                          style: _normalizeStyle({ paddingLeft: _ctx.select ? '0px' : '20px' })
                        }, [
                          _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                            _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                          ])
                        ], 6))
                      }), 128))
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                    _createElementVNode("td", _hoisted_65, [
                      _createVNode(_component_el_empty, { description: _ctx.description }, null, 8, ["description"])
                    ])
                  ]))
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
              _createElementVNode("label", null, [
                _createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                }, _hoisted_72, 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pagination.page,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pagination.page) = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.pagination.rowsPerPage,
          layout: "prev, pager, next",
          total: _ctx.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
      ])
    ])
  ]))
}